export const isMac = () => navigator.platform.indexOf('Mac') > -1;

export const isWindows = () => navigator.platform.indexOf('Win') > -1;
